import type { PageAnalyticSelectFragment } from '~/api/graphql/fragments/pageAnalytic.generated';
import type { TemplateType } from '~/types/template';
import type { IShopifyPageInfo } from '../types';

import { getLabelByTemplateType } from '~/utils';

export const getPageTitle = ({
  shopifyPageType,
  pageInfo,
}: {
  shopifyPageType?: TemplateType;
  pageInfo?: IShopifyPageInfo;
}) => {
  if (!shopifyPageType) return '';
  if (!pageInfo?.title) {
    return `${getLabelByTemplateType(shopifyPageType, { capitalize: true })} page`;
  }

  return pageInfo?.title;
};

export const checkEmptyMetricData = (metric: PageAnalyticSelectFragment[]) => {
  if (!metric.length || !metric[0].metrics) return true;

  return metric[0].metrics.every((metric) => !metric?.totalPageViewed);
};
